<template>
<div>
  <div class="textsq hidden-xs" >
    <div class="hidden-xs" style="margin: 0 auto;width:100%;">
      <div class="chaxuns">
        <div class="textleft" >
            <div>
                <p class="tit"> {{$t('data.headText.jojnt.pingpai')}}</p>
                <p class="ti2">Brand query</p>
            </div>
            <div class="dailss">
              <div class="dail"  @click="dail(index)" v-for="(item,index) in chaxun" :key="index" :style="index==chaxunid? 'color:#4A90E2':''">  {{item.title}} </div>
            </div>
        </div>
        <div class="ring">
          <div class="tigtim">
            <span class="tigtimwen" > {{chaxun[chaxunid].title}}</span>
            <span class="tigtimyi"> {{chaxun[chaxunid].content}} </span>
            <div style="display:flex;align-items: center;padding-top: 50px;">
              <input type="text" :placeholder="chaxun[chaxunid].title" v-model="shuju" style="paading-left:15px"   class="sufu">
              <button class="but" @click="openThe">{{$t('data.headText.jojnt.chaxun')}}</button>
            </div>

          </div>
          <div class="foot">
            <div>1.{{$t('data.headText.jojnt.fangwibianm')}}  </div>
            <div>2.{{$t('data.headText.jojnt.shouci')}}</div>
            <p>3.{{$t('data.headText.jojnt.gongz')}} </p>
            <p>4.{{$t('data.headText.jojnt.shouh')}}</p>
          </div>
          </div>
        </div>
      </div>
      <div v-if="alboxbool">
            <div  class="dahezi" @click="alboxbool = !alboxbool"></div>
            <div class="albox col-md-12">
                  <div class="alboxtop" >
                      <p class='alboxtoptitle'>{{$t('data.headText.jojnt.searchResult')}} </p>
                      <p class='alboxtopalert'>{{$t('data.headText.jojnt.gengdyi')}}</p>
                  </div>

                  <div class="alboxbott">
                        <p><span class="alboxkey">{{$t('data.headText.jojnt.chauxun')}}:</span><span class="alboxval">{{result.tel}}</span> </p>
                        <p><span class="alboxkey">{{$t('data.headText.jojnt.chuanxhsi')}}:</span><span class="alboxval">{{result.time}}</span> </p>
                        <p><span class="alboxkey">{{$t('data.headText.jojnt.searchResult')}}:</span><span class="alboxval2">{{result.res}}</span> </p>
                  </div>
            </div>
      </div>


  </div>
  <div class="xs-show visible-xs">
    <div v-if="alboxbool"  >
      <div class="dahezi"  @click="quxo"></div>
          <div class="alert" >
         <div class="alboxtop" >
              <p class='alboxtoptitle'>{{$t('data.headText.jojnt.searchResult')}}</p>
              <p class='alboxtopalert' style="font-size:1.33rem;">更多请在公众号查询</p>
          </div>
          <div class="alboxbott" style="padding:0">
                <p><span class="alboxkey" style="font-size: 1.66rem">查询号码:</span><span class="alboxval" style="font-size: 1.66rem">{{result.tel}}</span> </p>
                <p><span class="alboxkey" style="font-size: 1.66rem">查询时间:</span><span class="alboxval" style="font-size: 1.66rem">{{result.time}}</span> </p>
                <p><span class="alboxkey" style="font-size: 1.66rem">查询结果:</span><span class="alboxval2" style="font-size: 1.66rem">{{result.res}}</span> </p>
          </div>
    </div>
    </div>

    <div class="xs-show-heard">
      <div class="btn-group" style="width:20%;">
        <div type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img class="xs-show-img" src="../assets/group.svg"  alt="">
        </div>
        <ul class="dropdown-menu animite" style="width:750px;">
          <li style="width:100%;"><a @click="tomuen(4)">首页</a></li>
          <!-- <li style="width:100%;" v-for="(item,index) in muenlist" :key="index"><a :href="'/integration?id='+index+'&bannerid='+item.child ? item.child[0].child[0].id : ''">{{item.title}}--{{index}}--{{item.child ? item.child[0].child[0].id:''}}</a></li> -->
          <li style="width:100%;" v-for="(item,index) in muenlist" :key="index"><a href="#" @click="tomuen(0,index,item.child ? item.child[0].child[0].id:'')">{{item.title}}</a></li>
          <li style="width:100%;"><a href="#"  @click="tomuen(1)">视觉系列</a></li>
          <li style="width:100%;"><a href="#"  @click="tomuen(2)">联名合作</a></li>
          <li style="width:100%;"><a href="#"  @click="tomuen(3)">品牌查询</a></li>
        </ul>
      </div>
      <div style="width:60%;">品牌查询</div>
      <div style="width:20%;"></div>
    </div>
    <div class="xs-show-logo">
      <img src="../assets/shouquan.png">
    </div>
    <div class="security">
      <div @click="dail(index)" v-for="(item,index) in chaxun" :key="index" :style="index==chaxunid? 'color:#333333;font-size:1.4rem;font-weight:600;':''" style='cursor: pointer'>  {{item.title}} </div>
    </div>

    <div class="search">
        <input type="text" :placeholder="'请输入'+chaxun[chaxunid].title+'码'" v-model="shuju" style='padding-left:15px;box-sizing:border-box'>
    </div>
    <div class="btn_security" @click="openThe()">{{$t('data.headText.jojnt.chaxun')}}</div>
    <div class="question">
       <div>1.{{$t('data.headText.jojnt.fangwibianm')}}  </div>
        <div>2.{{$t('data.headText.jojnt.shouci')}}</div>
            <div>3.{{$t('data.headText.jojnt.gongz')}} </div>
            <div>4.{{$t('data.headText.jojnt.shouh')}}</div>
    </div>
  </div>

</div>
</template>

<script>
  import Bus from '../bus/index'
  export default {
    name: "checks",
    data() {
      return {
        'result':{
            'tel':null,
            'time':null,
            'res':null
        },
        shuju:'',
        alboxbool:false,
        chaxun:[{
            title:this.$t('data.headText.jojnt.daili'),
            content:'Anti-counterfeiting query',
            input:this.$t('data.headText.jojnt.qindail')
          },
          {
             title:this.$t('data.headText.jojnt.dangwei'),
            content:'Agent for the query',
            input:this.$t('data.headText.jojnt.qindanw')
          },
          {
             title:this.$t('data.headText.jojnt.tianmao'),
            content:'Tmall Authorization query',
            input:this.$t('data.headText.jojnt.qintian')
          }
        ],
        chaxunid:0,
        muenlist:null

      }
    },
    created() {
        Bus.$on('muen', (data) => {
              this.muenlist=data
            })
    },
    methods: {
      aaaa(e){

          this.alboxbool = false;
      },
      dail(id){
        this.chaxunid=id;

      },
      quxo(){
         this.alboxbool=false
      },
      openThe() {
        // var data=this.$refs.inptext.value
        if(this.chaxunid==1){
               this.axios.post('https://api.vvc.tw/dlxin/user/qrcode', this.qs.stringify(
                  {
                    "qrcode" : this.shuju
                  }
                )).then((res)=>{
                        this.result={
                              'tel':this.shuju,
                              'time':res.data.data.time,
                              'res':res.data.msg
                        }

                    this.alboxbool=true
                })
        }else{
             this.axios.post('https://api.vvc.tw/dlxin/user/authSearch', this.qs.stringify(
                  {
                    "bm" : this.shuju
                  }
                )).then((res)=>{
                        var str = res.data.msg
                        str = str.replace(/围/g,"为");
                        this.result={
                              'tel':this.shuju,
                              'time':res.data.data.time,
                              'res':str
                        }

                    this.alboxbool=true
                })
        }

      },
      tomuen(bool,id,index){
        var name='integration'
        if(bool==1){
          name='vision'
        }else if(bool==2){
          name='joint'
        }else if(bool==3){
          name='checks'
        }else if(bool=4){
          name=''
        }
        if(bool==0){
            this.$router.push({
            path: '/'+name,
            // query: {"id":item.id,},
            query:{id:id,index:index}
        })
        }else{
                 this.$router.push({
                      path: '/'+name
                  })
        }

      },
      muendata(){
        //  Bus.$on('muen', (data) => {
        //         this.muenlist=data
        //   })
      }
      // info(){
      //    this.$message.info('This is a normal message');
      // }
    },
     mounted() {
           this.muendata()
     },
       watch: {
          '$route.query'(to){
              this.chaxunid=to.id;
              Bus.$on('muen', (data) => {
                    this.muenlist=data
              })
          },


    }
  }
</script>

<style scoped >
@media screen and (max-width: 750px) {
    .btns button{
      background: none;
      border:none;
    }
    .xs-show{
      position: fixed;
      top: 0;
      left: 0;
      right:0;
      bottom: 0;
      background: white;
      z-index: 99;
    }
    /* .xs-show-img{
      position: absolute;
    } */
    .xs-show-logo{
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    .xs-show-logo img{
      width: 6.25rem;

    }
    .xs-show-heard{
      line-height:3.7rem;
      text-align: center;
      display: flex;
      justify-content:space-around;
      background:rgba(255,255,255,1);
      font-size:1.5rem;
      font-family:PingFangSC-Semibold;
      font-weight:600;
      color:rgba(51,51,51,1);
    }
    .xs-show-logo{
      width: 100%;
      height: 12.5rem;
    }
    .security{
      width: 80%;
      margin: 0 auto;
      display: flex;
    }
    .security div{

      font-size:1.16rem;
      font-family:PingFangSC-Semibold;
      font-weight:400;
      color:#666666;
      margin-right:2rem;
      line-height: 2.2rem;
      border-bottom:0.25rem solid white;
    }
    .search{
      width: 80%;
      margin: 0 auto;
      margin-top:6.67rem;
      line-height:3rem;
    }
    .search input{
      width: 100%;
      border: none;
      border-bottom:1px solid #D8D8D8;
    }
    .btn_security{
      width: 80%;
      margin: 0 auto;
      margin-top:3.5rem;
      line-height:4rem;
      color:white;
      background:rgba(26,125,253,1);
      border-radius:4px;
      text-align: center;
  }
  .question{
    width: 80%;
    margin: 0 auto;
    margin-top:2.83rem;
  }
  .question div{
    color:#AAAAAA;
    font-size:1rem;
  }
  .animite{
    overflow: hidden;
    animation: identifiers 0.25s linear forwards;
  }
  .animite li {
      width:100%;
      cursor: pointer
  }
  @keyframes identifiers {
    0%{
      height: 0px;
    }
    100%{
      height: 200px;
    }
  }
  .alert{
    position: absolute;
    z-index: 9999999;
    top: 20rem;
    font-size: 2rem;
    background: #fff;
    width: 90%;
    left: 5%;
    margin: 0 auto;
  }
  .alert .alboxtoptitle{
    font-size:2rem;
    font-family:PingFangSC-Medium;
    font-weight:500;
  }
  .alert .alboxkey{

  }
}



.dahezi{
 background-color: rgba(0,0,0,.8);
  width: 100%;
  height: 100%;
  position:absolute;
  top:0;
  left: 0;
  bottom: 0;
  right:0;
  z-index: 0;
  margin: 0 auto
}

.albox{
  background:white;
  border-radius:8px;
  border: 1px solid #ddd;
  position: absolute;
  top: -20%;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  width:686px;
  height:336px;
  z-index: 9;
}

.textsq{
  text-align: center;
  margin-top: 100px;
  height: 500px;
}
.textleft{
  margin-top: 50px;
  margin-left: 22%;
  min-width: 360px;
}
.chaxuns{
  display: flex;
  justify-content: space-around
}
.kuan{
  display: flex;
  justify-content: space-around;
  width: 1120px;
  margin: 0 auto;
   border: 1px solid yellow;
}
.foot{
  margin-top: 50px;
  text-align: left;
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(170,170,170,1);
  line-height:30px;
}

.foot> span {
  display: block;
}
.tit{
  font-size:24px;
  font-family:PingFangSC-Semibold;
  font-weight:600;
  color:rgba(74,74,74,1);
  line-height:33px;
}
.ti2{
  font-size:12px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:17px;
  letter-spacing:3px;
}
.dail{

  height:58px;
  font-size:16px;
  font-family:PingFangSC-Semibold;
  font-weight:600;
  line-height:58px;
  cursor: pointer;
}
.fanw{
  margin-top: 30px;
  height:22px;
  font-size:16px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:22px;
}
.tiam{
 margin-top: 30px;
font-size:16px;
font-family:PingFangSC-Regular;
font-weight:400;
color:rgba(153,153,153,1);
line-height:22px;
}
.ring{
  /* float: right; */
  /* margin-top: 50px; */
  /* border: 1px solid red; */
  margin-right: 25%;
  width: 950px;
  padding-left: 103px;
  box-sizing: border-box;
  border-left: 1px solid rgba(204,204,204,1);

}
.sufu{
  width:586px;
  height:40px;
  border: none;
  padding-left: 15px;
  background:rgba(238,239,240,1);
  border-radius:4px 0px 1px 0px;
}
.tigtim{
  margin-top: 50px;
  display: flex;
  flex-direction: column;
}
.tigtimwen{
  font-size:24px;
  padding-right: 103px;
  font-family:PingFangSC-Semibold;
  font-weight:600;
  color:rgba(51,51,51,1);
  line-height:33px;
}
.tigtimyi{
  font-size:12px;
  padding-right: 103px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:17px;
}

  .but{
  width:140px;
  height:40px;
  color: aliceblue;
  background:rgba(74,144,226,1);
  border-radius:4px;
}
/*
.albox{
  border: 1px solid red;
  width:686px;
  height:336px;
  background:rgba(255,255,255,1);
  border-radius:8px;
      position: fixed;
    left: 40%;
    top: 20%;
}
.alboxtop{
  display: flex;
  justify-content: space-between;
}
.alboxtoptitle{

  font-size:24px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(74,74,74,1);
  line-height:33px;
  padding-top:27px;
  padding-left: 24px;
}
.alboxtimg{
  height: 3px;
  width: 654px;
  margin-top: 21px;
}
.alboxtopalert{

  height:22px;
  font-size:15px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(81,136,255,1);
  line-height:22px;
  padding-top: 32px;
}
.alboxbott{
  text-align: left;
}
.alboxbott p {
 margin-top: 40px;
}
.alboxkey{
  font-size: 20px;
  color: #9B9B9B;

}
.alboxval{
  font-size: 20px;
  color: black;
}
.alboxval2{
  font-size: 20px;
  color: red;
}

*/




.alboxtop{
    display:flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px dashed #000;
  }

        .alboxtoptitle{
          font-size:24px;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(74,74,74,1);
          line-height:45px;
        }

        .alboxtopalert{
             font-size:16px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(81,136,255,1);
            line-height:33px;
        }

      .alboxbott{
          padding: 16px 0;
      }
      .alboxbott p{
             line-height: 60px;
            box-sizing: border-box;
            text-align :left ;
      }
  .alboxbott p .alboxkey{
               font-size:20px;
              font-family:PingFangSC-Medium;
              font-weight:500;
              color:rgba(155,155,155,1);
              line-height:40px;
              margin-right : 20px
  }
  .alboxval{

        color :#4A4A4A;
        font-size:20px;
        font-family:PingFangSC-Medium;
        font-weight:500;
      }
  .alboxval2{
  font-size: 20px;
  color: red;
}

</style>



// WEBPACK FOOTER //
// src/components/checks.vue